import { BaseEntity } from "./BaseEntity";

export class Company implements BaseEntity {
    constructor(public id?: number,
        public name?: string) {
    }

    parseJson(json: any): void {
        this.id = json.id;
        this.name = json.name;        
    }
}
